module.exports = __webpack_public_path__ + "Frame61.svg?3f68f04bea93761090daf6b4918a28c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame61.svg
// module id = 93
// module chunks = 0